import { boolean, number, object, setLocale, string } from 'yup'

import { stringify } from 'src/core/hooks/use-translation'

setLocale({
  mixed: {
    default: 'common.required',
    notType: 'common.required',
    required: 'common.required'
  }
})

export default object().shape({
  attach_travel_report: boolean().required(),
  email: string()
    .trim()
    .matches(
      /[A-Za-z0-9]{1,}@{1}[A-Za-z0-9.]{1,}/,
      'web.user-email-notification.email-invalid'
    )
    .max(
      1024,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 1024
      })
    )
    .required(),
  notification_status: string().trim().required(),
  reason_id: number().required(),
  validate_reason: boolean().required()
})
